__turbopack_context__.v({
  "backdrop": "AvatarUploadModal-module__eB2Yva__backdrop",
  "body": "AvatarUploadModal-module__eB2Yva__body",
  "closeBtn": "AvatarUploadModal-module__eB2Yva__closeBtn",
  "cropArea": "AvatarUploadModal-module__eB2Yva__cropArea",
  "cropContainer": "AvatarUploadModal-module__eB2Yva__cropContainer",
  "cropError": "AvatarUploadModal-module__eB2Yva__cropError",
  "cropLoading": "AvatarUploadModal-module__eB2Yva__cropLoading",
  "currentImg": "AvatarUploadModal-module__eB2Yva__currentImg",
  "currentPreview": "AvatarUploadModal-module__eB2Yva__currentPreview",
  "deleteBtn": "AvatarUploadModal-module__eB2Yva__deleteBtn",
  "dropIcon": "AvatarUploadModal-module__eB2Yva__dropIcon",
  "dropText": "AvatarUploadModal-module__eB2Yva__dropText",
  "dropZone": "AvatarUploadModal-module__eB2Yva__dropZone",
  "dropZoneActive": "AvatarUploadModal-module__eB2Yva__dropZoneActive",
  "footer": "AvatarUploadModal-module__eB2Yva__footer",
  "header": "AvatarUploadModal-module__eB2Yva__header",
  "hiddenInput": "AvatarUploadModal-module__eB2Yva__hiddenInput",
  "linkBtn": "AvatarUploadModal-module__eB2Yva__linkBtn",
  "loadingOverlay": "AvatarUploadModal-module__eB2Yva__loadingOverlay",
  "loadingText": "AvatarUploadModal-module__eB2Yva__loadingText",
  "modal": "AvatarUploadModal-module__eB2Yva__modal",
  "pickContainer": "AvatarUploadModal-module__eB2Yva__pickContainer",
  "previewLabel": "AvatarUploadModal-module__eB2Yva__previewLabel",
  "recropBtn": "AvatarUploadModal-module__eB2Yva__recropBtn",
  "spin": "AvatarUploadModal-module__eB2Yva__spin",
  "spinner": "AvatarUploadModal-module__eB2Yva__spinner",
  "title": "AvatarUploadModal-module__eB2Yva__title",
  "zoomControls": "AvatarUploadModal-module__eB2Yva__zoomControls",
  "zoomLabel": "AvatarUploadModal-module__eB2Yva__zoomLabel",
  "zoomSlider": "AvatarUploadModal-module__eB2Yva__zoomSlider",
});
